<template>
  <div id="timelogger-basic">


    <div class="grid">
      <div class="col m50">

        <inputfield _label="Timer" suffix="timer">
          <input type="number" min="0.25" max="3" step="0.25" class="number-btns" ref="hoursinput" placeholder="0" v-model.number="timelog.hours" @keydown.enter="create()">
        </inputfield>

      </div>
      <div class="col m50">

        <inputfield _label="Arbejdstype">
          <select v-model="timelog.worktype">
            <option value="undefined">Vælg arbejdstype...</option>
            <option v-for="(option,i) in worktypes" :key="'fdsf'+i" :value="option.key">{{option.title}}</option>
          </select>
          <div class="select-arrow">▾</div>
        </inputfield>
        
      </div>
    </div>
    
    <br>

    <inputfield _label="Note">
      <input type="text" v-model="timelog.title" placeholder="Hvad har du lavet?" @keydown.enter="create()">
    </inputfield>

    <br>

    <btn
      @click.native="create()" 
      color="primary" 
      @keydown.enter="create()"
      full
      :disabled="!ready"
    >Log {{timelog.hours||0}} time(r) på {{project.name}}</btn>

  </div>
</template>

<script>
import moment from 'moment'
import mixins from '../mixins.js'
import helpers from '../helpers.js'
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Inputfield from '.././components/Inputfield'
export default {
  components: { Box, Inputfield, Btn, },
  mixins: [ mixins.db, mixins.generic ],
  data: function () { return {
      
      timelog: {
        hours: undefined,
        title: undefined,
        project_key: undefined,
        billable: undefined,
        worktype: undefined,
      },

  } },
  computed: {

    worktypes(){ return this.$store.state.worktypes },
    //project(){ return this.$store.getters['projects/getOne']( this.timelog.project_key ) },
    project(){ return this.getOne( 'project', this.timelog.project_key ) },
    
    ready(){
      if( !this.timelog.project_key ) return false
      if( !this.timelog.hours ) return false
      if( !this.timelog.worktype ) return false
      if( !this.timelog.title ) return false
      if( !this.timelog.title.length ) return false
      return true
    },
    

  },
  methods: {

    multiSelectGetOption(options,key){
			if( !options ) return
			for( let option of options ) if( option.key == key ) return option.key
    },

    worktypeOnMultiSelect( item ){
      this.timelog.worktype = item.key
    },
    
    
    create(){
      
      this.timelog.user_key = this.$store.getters['users/my_user']['.key']
      this.timelog.date = moment().format('YYYY-MM-DD')
      this.timelog.created = moment().format('YYYY-MM-DD hh:mm:SS')
      this.timelog.date_timestamp = moment().unix(),
      this.timelog.created_timestamp = moment().unix(),

      this.fdb_push('timelogs',this.timelog)

      this.$store.commit('set__timeloggerBasic_active',false)
      this.triggerIconSignal('heart')

      this.$toasted.show( this.timelog.hours + ' timer tracket...', {
			  position: 'bottom-right',
			  duration: '2000',
		  })

    },
    

  },
  created(){

    this.timelog = JSON.parse(JSON.stringify(this.$store.state.timeloggerBasic.timelog))
    
  },

  mounted(){
    this.$nextTick(() => this.$refs.hoursinput.focus() )
  },

}
</script>



// WEBPACK FOOTER //
// TimeloggerBasic.vue?1e1c9940